import { RowModelGenerator } from '../services/row-model-generator';
import { splitFrozenRowObjectCells } from '../base/util';
/**
 * FreezeRowModelGenerator is used to generate grid data rows with freeze row and column.
 *
 * @hidden
 */
export class FreezeRowModelGenerator {
    constructor(parent) {
        this.parent = parent;
        this.rowModelGenerator = new RowModelGenerator(this.parent);
    }
    generateRows(data, notifyArgs, virtualRows) {
        let tableName;
        if (notifyArgs.renderFrozenRightContent || (notifyArgs.renderMovableContent && !this.parent.enableVirtualization)) {
            tableName = 'frozen-right';
        }
        else if (notifyArgs.renderMovableContent || notifyArgs.isFrozen) {
            tableName = 'movable';
        }
        else {
            tableName = this.parent.getFrozenLeftCount() ? 'frozen-left' : 'frozen-right';
        }
        if (notifyArgs.requestType === 'virtualscroll' && notifyArgs.virtualInfo.sentinelInfo.axis === 'X') {
            if (tableName !== 'movable') {
                return null;
            }
        }
        const row = this.parent.enableVirtualization && !notifyArgs.isFrozenRowsRender ? virtualRows
            : this.rowModelGenerator.generateRows(data, notifyArgs);
        for (let i = 0, len = row.length; i < len; i++) {
            row[parseInt(i.toString(), 10)].cells =
                splitFrozenRowObjectCells(this.parent, row[parseInt(i.toString(), 10)].cells, tableName);
        }
        return row;
    }
}
